import axios from 'axios'
import { ref, shallowRef } from 'vue'

/**
 * RED-256: the county × month table of one upload's completeness check, fetched
 * when its row is opened (the uploads list carries only the totals). The newest
 * request wins: opening another upload while one loads never shows the older one.
 */
export function useUploadCheck() {
  const detail = shallowRef(null)
  const loading = ref(false)
  const failed = ref(false)

  let sequence = 0

  const load = async uploadId => {
    const mine = ++sequence
    detail.value = null
    failed.value = false
    loading.value = true

    try {
      const response = await axios.get(route('upload.check', uploadId))

      if (mine === sequence) {
        detail.value = response.data
      }
    } catch (_error) {
      if (mine === sequence) {
        failed.value = true
      }
    } finally {
      if (mine === sequence) {
        loading.value = false
      }
    }
  }

  return { detail, loading, failed, load }
}
